import { useState, useEffect, useCallback, useRef } from 'react'
import './cdg31.css'
import Cdg31Header from './Cdg31Header'
import Cdg31Hero from './Cdg31Hero'
import { JeSuisJeVeux, Actualites, Toolbox, ContactBand, Footer } from './Cdg31Sections'
import { ChiffresCles, CarteHG, Partenaires, Temoignages, Newsletter } from './Cdg31NewSections'
import Cdg31Chat from './Cdg31Chat'

function RevealSection({ children }) {
  const ref = useRef(null)
  useEffect(() => {
    if (!ref.current) return
    const io = new IntersectionObserver(
      ([e]) => e.isIntersecting && e.target.classList.add('visible'),
      { threshold: 0.12 },
    )
    io.observe(ref.current)
    return () => io.disconnect()
  }, [])
  return <section className="cdg-reveal" ref={ref}>{children}</section>
}

export default function Cdg31Page() {
  const [chatOpen, setChatOpen] = useState(false)
  const [userProfile, setUserProfile] = useState('elu')
  const chatRef = useRef(null)
  const handleOpenChat = useCallback(() => setChatOpen(true), [])

  const handleAskAI = useCallback((message) => {
    setChatOpen(true)
    setTimeout(() => chatRef.current?.send(message), 400)
  }, [])

  return (
    <div className="cdg31-page">
      <Cdg31Header onOpenChat={handleOpenChat} />
      <Cdg31Hero onOpenChat={handleOpenChat} />
      <RevealSection><JeSuisJeVeux onProfileChange={setUserProfile} onAskAI={handleAskAI} /></RevealSection>
      <RevealSection><ChiffresCles /></RevealSection>
      <RevealSection><Actualites /></RevealSection>
      <RevealSection><CarteHG /></RevealSection>
      <RevealSection><Toolbox /></RevealSection>
      <RevealSection><Temoignages /></RevealSection>
      <RevealSection><Partenaires /></RevealSection>
      <RevealSection><Newsletter /></RevealSection>
      <ContactBand />
      <Footer />
      <Cdg31Chat ref={chatRef} open={chatOpen} onClose={setChatOpen} profile={userProfile} />
    </div>
  )
}
